<template>
    <div class="manageExceptionVue">
      <!-- Main Body Content area -->
        <div class="o-main-content-area o-main-content-area--padBotoomNone">

            <!-- Heading Section -->
            <div class="row c-responsive-fixwidth">
                <div class="col-md-12">
                    <h1 class="h1">Manage Exceptions: {{clientName}}</h1>
                </div>

            </div>
            <!-- /Heading Section -->

            <!-- list head -->

            <div class="c-common-space c-responsive-fixwidth">
                <div class="col-md-12 o-tab-area o-no-padding">
                    <ul class="o-tab-view o-tab-view--text">
                        <li><a  href="javascript: void(0)" :class="{'active':(this.tab=='signinSheet')?true:false}" @click="changeTab('signinSheet')">Sign-in Sheet</a></li>
                        <li><a href="javascript: void(0)" :class="{'active':(this.tab=='publicInfo')?true:false}" @click="changeTab('publicInfo')">Public Info</a></li>
                        <li><a href="javascript: void(0)" :class="{'active':(this.tab=='addEmployeeCSV')?true:false}" @click="changeTab('addEmployeeCSV')">Add Employee</a></li>
                        <li><a href="javascript: void(0)" :class="{'active':(this.tab=='notifyTab')?true:false}" @click="changeTab('notifyTab')">Notify</a></li>
                    </ul>
                </div>
            </div>

          
              <!-- Components -->
      <signinSheet v-if="this.tab == 'signinSheet'"/>
      <publicInfo v-if="this.tab == 'publicInfo'"/>      
      <addEmployeeCSV v-if="this.tab == 'addEmployeeCSV'"/>
      <notifyTab v-if="this.tab == 'notifyTab'"/>



        </div>
        <!-- /Main Body Content area -->

    </div>

</template>
<script>
    import signinSheet from './manageSignin';
    import publicInfo from './managePublic';
    import addEmployeeCSV from './addEmployeeCSV';
    import notifyTab from './notifyTab';

    import {
        bus
    } from '../../main';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../services.js';

    export default {
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                selectedClientId: 'selectedClientId'

            })
        },
        components: {
            'signinSheet': signinSheet,
            'publicInfo': publicInfo,
            'addEmployeeCSV': addEmployeeCSV,
            'notifyTab': notifyTab,

        },
        data() {
            return {
                tab: "signinSheet",
                clientName: '',
            }
        },
        methods: {
            changeTab(newTab) {
                this.tab = newTab;
            },
        },
        created() {
            service.get('client/' + this.selectedClientId, {
                    'Authorization': this.userToken
            })
            .then((res) => {
                this.clientName = res.data.result.user.display_name;
                //console.log(this.clientName);
            }).catch((err) => {
                console.log(err);
            });
        }
    }

</script>
<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/superAdmin/manageExceptions.vue